import { IChartOptions, IChartResult } from './chartSteps';

import {
	axisesAndLegends,
	IAxisesAndLegendsResult,
	tryApplyCustomColors,
	tryTranslateCaption
} from './chartSteps';
import { ApexOptions } from 'apexcharts';
import { ResultSet } from '@cubejs-client/core';
import { cloneDeep, merge } from 'lodash';

export default function lineChart(resultSet: ResultSet, options: IChartOptions, isGroupedByWeek: boolean, preloadedAxisNames: string[] | null = null): IChartResult {
	// IChartProps - IChartOptions
	let r = axisesAndLegends(resultSet, cloneDeep(options), isGroupedByWeek, preloadedAxisNames);
	r = tryApplyCustomColors(r);
	return toChartResult(r, options);
}

function toChartResult(result: IAxisesAndLegendsResult, options: IChartOptions): IChartResult {
	const defaultOptions: ApexOptions = {
		chart: {
			type: 'line'
		},
		markers: {
			size: 4
		},
		legend: {
			formatter: seriesName => tryTranslateCaption(seriesName, options.translate)
		},
		xaxis: {
			labels: {
				formatter: value => tryTranslateCaption(value, options.translate)
			}
		},
		tooltip: {
			y: {
				title: {
					formatter: val => tryTranslateCaption(val, options.translate)
				}
			},
			intersect: true,
			shared: false
		}
	};
	return {
		options: merge({}, result.output.chartResult.options, defaultOptions),
		series: result.output.pivots.series
	};
}
